<template>
  <byjove-menu :appsettings="appsettings"
               :show-login-button="false"
               :allow-anonymous-feedback="false"
               :feedback-recipient-options="feedbackRecipientOptions"
               :expose-root="false"
               :include-about-link="$store.state.user_is_admin">

    <b-dropdown-item aria-role="menuitem"
                     v-if="$store.state.expose_home"
                     has-link>
      <router-link to="/">Home</router-link>
    </b-dropdown-item>

    <b-dropdown-item aria-role="menuitem"
                     has-link>
      <router-link to="/benefits">Benefits</router-link>
    </b-dropdown-item>

    <b-dropdown-item aria-role="menuitem"
                     has-link>
      <router-link to="/household-shopper">Household Shopper</router-link>
    </b-dropdown-item>

    <b-dropdown-item v-if="$store.state.user.member"
                     aria-role="menuitem" has-link>
      <router-link to="/equity">Equity</router-link>
    </b-dropdown-item>

    <b-dropdown-item v-if="$store.state.user.member"
                     aria-role="menuitem" has-link>
      <router-link to="/patronage">Patronage</router-link>
    </b-dropdown-item>

    <b-dropdown-item v-if="$store.state.user.community_discount"
                     aria-role="menuitem" has-link>
      <router-link to="/community-discount">Community Discount</router-link>
    </b-dropdown-item>

    <b-dropdown-item v-if="$store.state.user.member_volunteer && $store.state.user.volunteer_scheduling_allowed"
                     aria-role="menuitem" has-link>
      <router-link to="/member-volunteer">Member Volunteer</router-link>
    </b-dropdown-item>

    <b-dropdown-item aria-role="menuitem"
                     has-link>
      <router-link to="/account">My Account</router-link>
    </b-dropdown-item>

    <b-dropdown-item v-if="$hasPerm('mgmt_messages.list')"
                     aria-role="menuitem"
                     has-link>
      <router-link to="/general-manager">General Manager</router-link>
    </b-dropdown-item>

    <b-dropdown-item v-if="$hasPerm('mgmt_messages.list')"
                     aria-role="menuitem"
                     has-link>
      <router-link to="/member-engagement">Member Engagement</router-link>
    </b-dropdown-item>

    <template v-slot:header>
      <a v-if="showHeader"
         href="https://sac.coop">
        <img src="/assets/snfc_logo_horizontal_web_2021.png"
             alt="Go to sac.coop" />
      </a>
      <!-- TODO: this seems like a bit of a hack? but must return *something* -->
      <!-- here, or else vue will use *default* slot contents instead -->
      <span v-if="!showHeader"></span>
    </template>
  </byjove-menu>
</template>

<script>
import {ByjoveMenu} from 'byjove'
import appsettings from '../appsettings'

export default {
    name: 'AppNav',
    components: {
        ByjoveMenu,
    },
    data() {
        return {
            appsettings: appsettings,
            feedbackRecipientOptions: [],
        }
    },
    computed: {
        showHeader: function() {
            // don't show header image, for login page only
            if (this.$route.name == 'login') {
                return false
            }
            return true
        },
    },
    created: function() {
        this.setFeedbackOptions()
    },
    watch: {
        '$store.state.settings_established': 'setFeedbackOptions',
    },
    methods: {
        setFeedbackOptions() {
            if (this.$store.state.expose_home) {
                this.feedbackRecipientOptions = [
                    {label: "Membership", value: 'veranda_feedback'},
                    {label: "Finance", value: 'veranda_feedback_finance'},
                    {label: "General Manager", value: 'veranda_feedback_general_manager'},
                    {label: "Technical", value: 'veranda_feedback_technical'},
                ]
            } else {
                this.feedbackRecipientOptions = []
            }
        },
    },
}
</script>
